import { api } from '../api'
import { ModelLog, ModelCreateFromRFQPending } from './models'
import { setToModel } from '@/utils/objects'
import { Service } from '../Service'
import { getCurrentEmployee } from '@/utils/shared'

const ENDPOINTS = {
  GET: 'CustomerPOFollowUps/Get',
  GET_DYNAMIC: 'CustomerPOFollowUps/GetAllDynamic',
  POST: 'CustomerPOFollowUps/Create',
  PATCH: 'CustomerPOFollowUps/Patch',
  PUT: 'CustomerPOFollowUps/Put',
  DELETE: 'CustomerPOFollowUps/Delete',
  CREATE_LOG: 'CustomerPOFollowUpLogs/Create',
  CREATE_FROM_RFQ_PENDING: 'CustomerPOFollowUps/CreateFromRFQPending'
}

const FIELDS_CONFIG = {
  'orderPhaseID': {
    label: 'order-phase',
    type: 'select'
  },
  'exchAgreementSigned': {
    label: 'exch-agreement-signed',
    type: 'checkbox'
  },
  'unitShipped': {
    label: 'unit-shipped',
    type: 'checkbox'
  },
  'coreReceived': {
    label: 'core-received',
    type: 'checkbox'
  },
  'qty': {
    label: 'qty'
  },
  'repairCostsApproved': {
    label: 'repair-costs-approved',
    type: 'checkbox'
  },
  'unitReceivedCustomer': {
    label: 'unit-received-customer',
    type: 'checkbox'
  },
  'lastInfo': {
    label: 'last-info'
  },
  'orderPhasePersonInChargeEmployeeID': {
    label: 'phase-employee',
    type: 'select'
  },
  'dateInPhase': {
    type: 'date',
    label: 'date-in-phase'
  },
  'priorityID': {
    type: 'select',
    label: 'priority'
  },
  'reminderDate': {
    label: 'reminder-date',
    type: 'date'
  },
  'customerCompanyID': {
    type: 'select',
    label: 'customer'
  },
  'requestedDate': {
    type: 'date',
    label: 'requested-date'
  },
  'rfqTypeID': {
    type: 'select',
    label: 'rfq-type'
  },
  'customerContactID': {
    type: 'select',
    label: 'customer-contact'
  },
  'po': {
    label: 'po'
  },
  'partID': {
    type: 'select',
    label: 'part'
  },
  'partSN': {
    label: 'part-SN'
  },
  'price': {
    label: 'price'
  },
  'currencyID': {
    type: 'select',
    label: 'currency'
  },
  'conditionID': {
    type: 'select',
    label: 'condition'
  },
  'quoteDate': {
    label: 'quote-date',
    type: 'date'
  },
  'supplyDate': {
    label: 'supply-date'
  },
  'tagInfoCompanyID': {
    type: 'select',
    label: 'tag-info'
  },
  'tagDate': {
    label: 'tag-date',
    type: 'date'
  },
  'traceabilityCompanyID': {
    type: 'select',
    label: 'traceability-company'
  },
  'remarks': {
    label: 'remarks'
  },
  'exchangeCoreValue': {
    label: 'exchange-core-value'
  },
  'exchangeCoreValueCurrencyID': {
    type: 'select',
    label: 'exchange-core-value-currency'
  },
  'exchangeConditionID': {
    type: 'select',
    label: 'exchange-condition'
  },
  'exchangeCoreReceived': {
    type: 'checkbox',
    label: 'exchange-core-received'
  },
  'coreDueDate': {
    type: 'date',
    label: 'core-due-date'
  }
}

class CustomerPOFollowUp extends Service {
  async createLog (data) {
    const _data = setToModel(new ModelLog(), data)
    delete _data['id']

    return api
      .post(`${ENDPOINTS.CREATE_LOG}`, _data)
  }
  async updateNotification ({ field, id, labelSelect, value }) {
    const config = FIELDS_CONFIG[field]

    if (!config) {
      return Promise.reject(new Error(`Config is empty`))
    }

    const { label, type } = config
    const employee = getCurrentEmployee() || {}
    const { name } = employee
    const fieldLabel = window.app.L10n(label)
    labelSelect = labelSelect || ''

    let description = ''

    switch (type) {
      case 'date':
      case 'checkbox':
        description = `${name} ${value ? 'checked' : 'unchecked'} the "${fieldLabel}"`
        break
      case 'select':
        description = `${name} ${value ? 'select' : 'clear'} "${labelSelect}" for the "${fieldLabel}"`
        break
      default:
        description = `${name} change the "${fieldLabel}" to "${value}"`
    }

    return this.createLog({ customerPOFollowUpID: id, description })
  }

  async createFromRFQPending (data) {
    const _data = { ...data }
    delete _data['id']

    return api
      .post(ENDPOINTS.CREATE_FROM_RFQ_PENDING, _data)
  }
}

export const ServiceCustomerPOFollowUp = new CustomerPOFollowUp({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})

export {
  ModelLog,
  ModelCreateFromRFQPending
}
